import React, { useState, useEffect } from 'react';
import FixtureMundial from '../../FixtureMundial/FixtureMundial';
import { supabase } from '../../../supabaseClient';
import Mercado from '../../Mercado/Mercado';
import ModalSorteo from '../../ModalSorteo/ModalSorteo';
import CardJugador from '../../CardJugador/CardJugador';
import CanchaGrid from '../../CanchaGrid/CanchaGrid';
import MenuContextual from '../../MenuContextual/MenuContextual';
import { COORDENADAS_FORMACIONES } from '../../../constants/tactics';

// EquipoTactico.js
import Tutorial from '../../../components/Tutorial/Tutorial';
import { TUTORIALES } from '../../../constants/tutorialesConfig';

const CONFIG_SUPLENTES = [
  { id: 20, pos: 'ARQ', label: 'SU' },
  { id: 21, pos: 'DEF', label: 'SD' },
  { id: 22, pos: 'VOL', label: 'SV' },
  { id: 23, pos: 'DEL', label: 'SL' },
];

const EquipoTactico = ({
  session,
  draftResult, setDraftResult,
  mostrarSorteo, setMostrarSorteo,
  equipoActual, setEquipoActual,
  restriccionesActualizadas,
  posActual,
  mercadoAbierto, setMercadoAbierto,
  posicionSeleccionada, setPosicionSeleccionada,
  indexAEditar, setIndexAEditar,
  slotSeleccionado, setSlotSeleccionado,
  menuContextual, setMenuContextual,
  jornadaActiva = 1,
  jornadaViendo = 1, setJornadaViendo,
  confirmado, setConfirmado,
  capitanIndex, setCapitanIndex,
  ventana, setVentana,
  jornadasDisponibles, setJornadasDisponibles,
  efectosComodines, setEfectosComodines,
  presupuestoBonus, setPresupuestoBonus,
  sorteoCheckpoint,
  onCopiarALibre,
}) => {

  const cerrarTodo = () => {
    setMercadoAbierto(false);
    setSlotSeleccionado(null);
    setMenuContextual(null);
  };

  const [equipoHistorico, setEquipoHistorico] = useState(null);
  // ⚠️ jornadaViendo local — ignora resets del padre al ganar foco
  const [jornadaViendoLocal, setJornadaViendoLocal] = React.useState(jornadaViendo);
  // Sincronizar solo cuando jornadaActiva cambia (nueva jornada real), no en refetches
  const jornadaActivaAnterior = React.useRef(jornadaActiva);
  // Sincronizar capitanLocal con capitanIndex del padre
  React.useEffect(() => { setCapitanLocal(capitanIndex); }, [capitanIndex]);
  React.useEffect(() => {
    if (jornadaActiva !== jornadaActivaAnterior.current) {
      jornadaActivaAnterior.current = jornadaActiva;
      setJornadaViendoLocal(jornadaActiva);
      setJornadaViendo(jornadaActiva);
      setEquipoHistorico(null);
      setPuntajeJugador({});
      setPuntajeBase({});
    }
  }, [jornadaActiva]);
  const [confirmando, setConfirmando] = useState(false);
  const [restriccionHover, setRestriccionHover] = useState(null);
  const [panelTab, setPanelTab] = useState('restricciones');
  const [toast, setToast] = useState(null);
  const [puntajeJugador, setPuntajeJugador] = useState({}); // { jugador_id: pts_total }
  const [puntajeBase, setPuntajeBase] = useState({}); // { jugador_id: pts_base }
  const [jornadasLocales, setJornadasLocales] = useState([]); // jornadas cargadas localmente
  const [cargandoJornada, setCargandoJornada] = useState(false);
  const [capitanLocal, setCapitanLocal] = useState(null); // capitán local sincronizado
  const [mobileTab, setMobileTab] = useState('restricciones'); // 'suplentes' | 'restricciones' | 'comodines'
  const [restriccionSeleccionada, setRestriccionSeleccionada] = useState(null);

  const mostrarToast = (msg, tipo = 'ok') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast(null), 3000);
  };

  // Solo recargar al ganar foco (comodines, confirmado pueden cambiar en otra pestaña)
  const recargarEfectos = async () => {
    const { data: draft } = await supabase.from('drafts')
      .select('confirmado, efectos_comodines, capitan_index')
      .eq('user_id', session.user.id).eq('jornada', jornadaActiva).maybeSingle();
    if (draft) {
      setConfirmado(draft.confirmado || false);
      setCapitanIndex(draft.capitan_index ?? null);
      const efectos = draft.efectos_comodines || [];
      setEfectosComodines(efectos);
      // ⚠️ NO BORRAR: suma TODOS los efectos con monto (dinero_extra, sabotaje, trampa_combo)
      const totalBonus = efectos
        .filter(e => typeof e.monto === 'number' && e.monto !== 0)
        .reduce((acc, e) => acc + e.monto, 0);
      setPresupuestoBonus(totalBonus);
    }
  };


  // Cargar jornadas disponibles — solo al montar
  useEffect(() => {
    supabase.from('drafts').select('jornada, confirmado')
      .eq('user_id', session.user.id).gt('jornada', 0).order('jornada')
      .then(({ data }) => { if (data?.length) setJornadasLocales(data); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.user.id]);

  useEffect(() => {
    window.addEventListener('focus', recargarEfectos);
    // Limpiar SIEMPRE al cambiar jornada antes de cualquier fetch
    setPuntajeJugador({});
    setPuntajeBase({});
    let cancelado = false;
    const cargarPuntaje = async () => {
      if (jornadaViendoLocal > jornadaActiva) { if (!cancelado) setPuntajeJugador({}); return; }
      const { data: pts } = await supabase.from('jugador_puntos_fecha')
        .select('jugador_id, puntos_total, puntos_base').eq('jornada', jornadaViendoLocal);
      if (cancelado) return;
      if (pts?.length) {
        const mapa = {}; const mapaBase = {};
        pts.forEach(p => { mapa[p.jugador_id] = p.puntos_total; mapaBase[p.jugador_id] = p.puntos_base ?? p.puntos_total; });
        if (!cancelado) { setPuntajeJugador(mapa); setPuntajeBase(mapaBase); }
        return;
      }
      // Sin puntos para esta jornada — fallback solo si estamos VIENDO una jornada pasada
      if (jornadaViendoLocal < jornadaActiva && jornadaViendoLocal > 1) {
        const { data: pts2 } = await supabase.from('jugador_puntos_fecha')
          .select('jugador_id, puntos_total, puntos_base').eq('jornada', jornadaViendoLocal - 1);
        if (cancelado) return;
        if (pts2?.length) {
          const mapa = {}; const mapaBase = {};
          pts2.forEach(p => { mapa[p.jugador_id] = p.puntos_total; mapaBase[p.jugador_id] = p.puntos_base ?? p.puntos_total; });
          if (!cancelado) { setPuntajeJugador(mapa); setPuntajeBase(mapaBase); }
          return;
        }
      }
      // Limpiar puntaje — estamos en jornada activa sin puntos aún
      if (!cancelado) { setPuntajeJugador({}); setPuntajeBase({}); }
    };
    cargarPuntaje();
    return () => { cancelado = true; window.removeEventListener('focus', recargarEfectos); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.user.id, jornadaActiva, jornadaViendoLocal]);

  // ⚠️ NO BORRAR: autosave del equipo — UPDATE solo el campo equipo, no toca efectos_comodines ni otros campos
  useEffect(() => {
    if (!session?.user?.id || !jornadaActiva || Object.keys(equipoActual).length === 0) return;
    if (!ventanaAbierta()) return; // Solo autosave cuando la ventana está abierta
    const timer = setTimeout(async () => {
      await supabase.from('drafts')
        .update({ equipo: equipoActual })
        .eq('user_id', session.user.id)
        .eq('jornada', jornadaActiva);
    }, 600);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipoActual]);

  const ventanaAbierta = () => {
    if (!ventana) return false; // Sin ventana activa no se puede editar
    const ahora = new Date();
    return ahora >= new Date(ventana.apertura) && ahora <= new Date(ventana.cierre);
  };

  const puedeEditar = !confirmado && ventanaAbierta();

  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);

  const pedirConfirmacion = () => {
    const titulares = Object.entries(equipoActual).filter(([k]) => Number(k) <= 10).map(([,v]) => v).filter(Boolean);
    const suplentes = Object.entries(equipoActual).filter(([k]) => Number(k) >= 20).map(([,v]) => v).filter(Boolean);
    if (titulares.length < 11) { mostrarToast(`Faltan ${11 - titulares.length} titulares`, 'error'); return; }
    if (suplentes.length < 4)  { mostrarToast(`Faltan ${4 - suplentes.length} suplentes`, 'error'); return; }
    if (capitanIndex === null)  { mostrarToast('Elegí un capitán antes de confirmar', 'error'); return; }
    if (disponible < 0)        { mostrarToast('El presupuesto está excedido', 'error'); return; }
    const incumplidas = restriccionesActualizadas.filter(r => !r.cumplida && !r.anulada);
    if (incumplidas.length > 0) { mostrarToast(`${incumplidas.length} restricción${incumplidas.length > 1 ? 'es' : ''} sin cumplir`, 'error'); return; }
    setMostrarConfirmar(true);
  };
  const confirmarEquipo = async () => {
    setConfirmando(true);
    await supabase.from('drafts').upsert({
      user_id: session.user.id,
      jornada: jornadaActiva,
      formacion: draftResult.formacion,
      presupuesto: draftResult.presupuesto,
      restricciones: restriccionesActualizadas,
      equipo: equipoActual,
      confirmado: true,
      confirmado_en: new Date().toISOString(),
      capitan_index: capitanIndex,
    }, { onConflict: 'user_id,jornada' });
    setConfirmado(true);
    setConfirmando(false);
  };

  const handleClickSlot = (e, i, pos) => {
    if (!puedeEditar) return;
    if (equipoHistorico) return; // ⚠️ bloqueado en modo histórico
    if (slotSeleccionado === i) { cerrarTodo(); return; }
    if (mercadoAbierto) { cerrarTodo(); return; }
    if (!equipoActual[i]) {
      setSlotSeleccionado(i);
      setPosicionSeleccionada(pos);
      setIndexAEditar(i);
      setMercadoAbierto(true);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      setSlotSeleccionado(i);
      setMenuContextual({ index: i, pos, esSuplente: false, x: rect.left + rect.width / 2, y: rect.top });
    }
  };

  const handleClickSuplente = (e, slot) => {
    if (!puedeEditar) return;
    if (equipoHistorico) return; // ⚠️ bloqueado en modo histórico
    if (slotSeleccionado === slot.id) { cerrarTodo(); return; }
    if (mercadoAbierto) { cerrarTodo(); return; }
    if (!equipoActual[slot.id]) {
      setSlotSeleccionado(slot.id);
      setPosicionSeleccionada(slot.pos);
      setIndexAEditar(slot.id);
      setMercadoAbierto(true);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      setSlotSeleccionado(slot.id);
      setMenuContextual({ index: slot.id, pos: slot.pos, esSuplente: true, x: rect.right + 8, y: rect.top });
    }
  };

  const handleCapitan = async (idx) => {
    const nuevo = capitanIndex === idx ? null : idx;
    setCapitanIndex(nuevo);
    setMenuContextual(null);
    setSlotSeleccionado(null);
    await supabase.from('drafts').upsert({ user_id: session.user.id, jornada: jornadaActiva, capitan_index: nuevo }, { onConflict: 'user_id,jornada' });
  };

  const handleIntercambiar = (idxA, idxB) => {
    setEquipoActual(prev => ({
      ...prev,
      [idxA]: prev[idxB],
      [idxB]: prev[idxA],
    }));
    setMenuContextual(null);
    setSlotSeleccionado(null);
  };

  const handleQuitar = (idx) => {
    setEquipoActual(prev => { const n = { ...prev }; delete n[idx]; return n; });
    setMenuContextual(null);
    setSlotSeleccionado(null);
  };

  // Presupuesto disponible
  const presupuestoNum = parseInt(String(draftResult.presupuesto).replace(/\D/g, '')) *
    (String(draftResult.presupuesto).includes('M') ? 1000000 : 1);
  const gastado = Object.values(equipoActual).reduce((acc, j) => acc + (j?.precio || 0), 0);
  // Si el mercado está abierto, el jugador del slot que se edita "vuelve" al presupuesto
  const precioSlotActual = (mercadoAbierto && indexAEditar !== null) ? (equipoActual[indexAEditar]?.precio || 0) : 0;
  const disponible = presupuestoNum + presupuestoBonus - gastado + precioSlotActual;

  // ── Widget fixture ─────────────────────────────────────────────────────────
  const fixtureWidget = (
    <div style={{ maxWidth: '960px', margin: '8px auto 0', padding: '0 10px 16px', height: '480px' }}>
      <FixtureMundial jornadaActiva={jornadaActiva} />
    </div>
  );


  // ── Calcular qué suplentes muestran puntos ───────────────────────────────────
  const POS_SUPLENTE = { 20: 'ARQ', 21: 'DEF', 22: 'VOL', 23: 'DEL' };
  const SLOTS_TIT = [0,1,2,3,4,5,6,7,8,9,10];
  const equipoVisible = equipoHistorico ? (equipoHistorico.equipo || {}) : equipoActual;
  const puntajeVisible = Object.keys(puntajeJugador).length > 0 && Object.keys(equipoVisible).length > 0 ? (() => {
    const filtrado = { ...puntajeJugador };
    [20, 21, 22, 23].forEach(slotSup => {
      const jug = equipoVisible[String(slotSup)];
      if (!jug?.id) return;
      const posSup = POS_SUPLENTE[slotSup];
      const titularesDePos = SLOTS_TIT.filter(s => {
        const t = equipoVisible[String(s)];
        const posTit = t?.posicion?.sigla || t?.posicion;
        return t?.id && posTit === posSup;
      });
      const titularesConPuntos = titularesDePos.filter(s => {
        const t = equipoVisible[String(s)];
        return t?.id && puntajeJugador[t.id] != null;
      }).length;
      if (titularesConPuntos >= titularesDePos.length) delete filtrado[jug.id];
    });
    // Duplicar puntos del capitán en el mapa para que la card muestre el valor correcto
    // Capitán: total + puntos_base (base se duplica, bonus no)
    const capIdxFinal = equipoHistorico ? equipoHistorico.capitan_index : capitanIndex;
    if (capIdxFinal != null) {
      Object.entries(equipoVisible).forEach(([slot, jug]) => {
        if (String(slot) === String(capIdxFinal) && jug?.id && filtrado[jug.id] != null) {
          const base = puntajeBase[jug.id] ?? filtrado[jug.id];
          const bonus = filtrado[jug.id] - base;
          filtrado[jug.id] = (base * 2) + bonus; // base duplicada + bonus normal
        }
      });
    }
    return filtrado;
  })() : {};

  return (
    <>
    <div className="tactical-screen-container">
      {mostrarSorteo && (
        <ModalSorteo
          userId={session.user.id}
          jornadaActiva={jornadaActiva}
          checkpoint={sorteoCheckpoint}
          alFinalizar={async (res) => {
          setDraftResult(res);
          setMostrarSorteo(false);
          setEquipoActual({}); // limpiar equipo anterior de la fecha pasada
          await supabase.from('drafts').upsert({
            user_id: session.user.id,
            jornada: jornadaActiva,
            formacion: res.formacion,
            presupuesto: res.presupuesto,
            restricciones: res.restricciones,
            equipo: {},
            ruleta_girada: true,
          }, { onConflict: 'user_id,jornada' });
        }} />
      )}

      {cargandoJornada && (
        <div style={{ position:'absolute', inset:0, background:'rgba(5,8,16,0.7)', zIndex:50,
          display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'10px' }}>
          <div style={{ color:'#00f2ff', fontSize:'0.9rem', fontWeight:'bold', letterSpacing:'2px' }}>
            Cargando...
          </div>
        </div>
      )}
      {mercadoAbierto && (
        <Mercado
          posicionInicial={posicionSeleccionada}
          onClose={cerrarTodo}
          equipoActual={equipoActual}
          restriccionesActualizadas={restriccionesActualizadas}
          onSeleccionarJugador={async (jugador) => {
            // Si hay un jugador en el slot, su precio se "devuelve"
            const precioActual = equipoActual[indexAEditar]?.precio || 0;
            const costo = (jugador.precio || 0) - precioActual;
            if (disponible - costo < 0) {
              mostrarToast(`¡Presupuesto insuficiente! Te faltan $${(costo - disponible).toLocaleString()}`, 'error');
              return;
            }
            const nuevoEquipo = { ...equipoActual, [indexAEditar]: jugador };
            setEquipoActual(nuevoEquipo);
            cerrarTodo();
            await supabase.from('drafts').upsert({
              user_id: session.user.id,
              jornada: jornadaActiva,
              formacion: draftResult.formacion,
              presupuesto: draftResult.presupuesto,
              restricciones: draftResult.restricciones,
              equipo: nuevoEquipo,
            }, { onConflict: 'user_id,jornada' });
          }}
        />
      )}

      <div className="main-tactical-layout">
        {/* SUPLENTES */}
        <aside className="left-panel-compact">
          <h3 className="panel-title-compact">Suplentes</h3>
          {CONFIG_SUPLENTES.map(slot => (
            <div
              key={slot.id}
              className={`subs-slot-compact
                ${slotSeleccionado !== null && slotSeleccionado !== slot.id ? 'slot-dimmed' : ''}
                ${slotSeleccionado === slot.id ? 'slot-selected' : ''}
              `}
              onClick={(e) => handleClickSuplente(e, slot)}
            >
              <CardJugador jugador={(equipoHistorico ? equipoHistorico.equipo || {} : equipoActual)[slot.id]} posicion={slot.pos} nombre={slot.label} isMini puntos={puntajeVisible[(equipoHistorico ? equipoHistorico.equipo || {} : equipoActual)[slot.id]?.id] ?? null} />
            </div>
          ))}
        </aside>

        {/* CANCHA */}
        <CanchaGrid
          posiciones={equipoHistorico
            ? (COORDENADAS_FORMACIONES[equipoHistorico.formacion] || COORDENADAS_FORMACIONES['4-3-3'])
            : posActual}
          equipo={equipoHistorico ? (equipoHistorico.equipo || {}) : equipoActual}
          slotSeleccionado={equipoHistorico ? null : slotSeleccionado}
          onClickSlot={equipoHistorico ? () => {} : handleClickSlot}
          jugadoresDestacados={restriccionHover}
          capitanIndex={equipoHistorico ? equipoHistorico.capitan_index : capitanIndex}
          puntajeJugador={puntajeVisible}
          infoBar={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', overflow: 'hidden' }}>
              <span>FORMACIÓN {equipoHistorico ? equipoHistorico.formacion : draftResult.formacion}</span>
              <span className="separator">|</span>
              <span>PRESUPUESTO ${presupuestoNum.toLocaleString()}</span>
              {Object.keys(puntajeVisible).length > 0 && (() => {
                const equipo_t = equipoHistorico ? (equipoHistorico.equipo || {}) : equipoActual;
                const capIdx_t = equipoHistorico ? equipoHistorico.capitan_index : capitanIndex;
                let totalPts = 0;
                Object.entries(equipo_t).forEach(([slot, jug]) => {
                  if (!jug?.id) return;
                  const pts = puntajeVisible[jug.id];
                  if (pts == null) return;
                  totalPts += pts; // puntajeVisible ya tiene capitán con base x2 + bonus
                });
                return totalPts > 0 ? (
                  <>
                    <span className="separator">|</span>
                    <span style={{ color: '#00f2ff', fontWeight: 'bold' }}>{totalPts} pts</span>
                  </>
                ) : null;
              })()}
              {(() => {
                // Siempre incluir la jornada activa, aunque no tenga draft todavía
                // Mostrar todas las jornadas con draft, sin limitar por jornadaActiva
                const fuenteJornadas = jornadasLocales.length > 0 ? jornadasLocales : jornadasDisponibles;
                const botones = fuenteJornadas.filter(j => j.jornada > 0);
                return botones.length > 1 && (
                <>
                  <span className="separator">|</span>
                  {botones.map(j => (
                    <button key={j.jornada} onClick={async () => {
                      setCargandoJornada(true);
                      setJornadaViendoLocal(j.jornada); setJornadaViendo(j.jornada);
                      if (j.jornada === jornadaActiva) {
                        // Recargar el draft de la jornada activa desde DB para asegurar datos frescos
                        const { data: draftActivo } = await supabase.from('drafts').select('*')
                          .eq('user_id', session.user.id).eq('jornada', jornadaActiva).maybeSingle();
                        if (draftActivo?.equipo && Object.keys(draftActivo.equipo).length > 0) {
                          setEquipoActual(draftActivo.equipo);
                          setCapitanIndex(draftActivo.capitan_index ?? null);
                          setCapitanLocal(draftActivo.capitan_index ?? null);
                        }
                        setEquipoHistorico(null);
                        setPuntajeJugador({}); setPuntajeBase({}); // limpiar mientras carga
                        // Cargar desde jugador_puntos_fecha
                        const { data: pts } = await supabase.from('jugador_puntos_fecha')
                          .select('jugador_id, puntos_total, puntos_base').eq('jornada', j.jornada);
                        if (pts?.length) {
                          const mapa = {}; const mapaBase = {};
                          pts.forEach(p => { mapa[p.jugador_id] = p.puntos_total; mapaBase[p.jugador_id] = p.puntos_base ?? p.puntos_total; });
                          setPuntajeJugador(mapa); setPuntajeBase(mapaBase);
                        } else {
                          // Sin puntos para esta jornada — no hacer fallback si es la jornada activa
                          setPuntajeJugador({}); setPuntajeBase({});
                        }
                      setCargandoJornada(false);
                      } else {
                        const { data } = await supabase.from('drafts').select('*').eq('user_id', session.user.id).eq('jornada', j.jornada).maybeSingle();
                        setEquipoHistorico(data);
                        // Cargar puntos históricos desde jugador_puntos_fecha
                        try {
                          const { data: ptsH } = await supabase.from('jugador_puntos_fecha')
                            .select('jugador_id, puntos_total, puntos_base').eq('jornada', j.jornada);
                          if (ptsH?.length) {
                            const mapa = {}; const mapaBase = {};
                            ptsH.forEach(p => { mapa[p.jugador_id] = p.puntos_total; mapaBase[p.jugador_id] = p.puntos_base ?? p.puntos_total; });
                            setPuntajeJugador(mapa); setPuntajeBase(mapaBase);
                          } else {
                            setPuntajeJugador({}); setPuntajeBase({});
                          }
                        } catch(e) { setPuntajeJugador({}); }
                      setCargandoJornada(false);
                      }
                    }}
                      style={{ padding:'2px 8px', borderRadius:'4px', fontSize:'0.72rem', fontWeight:'bold', cursor:'pointer', border:`1px solid ${jornadaViendoLocal === j.jornada ? '#00f2ff' : '#334155'}`, background: jornadaViendoLocal === j.jornada ? '#00f2ff22' : 'transparent', color: jornadaViendoLocal === j.jornada ? '#00f2ff' : '#475569' }}>
                      Fecha {j.jornada}{j.confirmado ? '' : ''}
                    </button>
                  ))}
                  {jornadaViendoLocal !== jornadaActiva && (
                    <span style={{ color:'#f59e0b', fontSize:'0.68rem', fontStyle:'italic' }}>solo lectura</span>
                  )}
                </>
                );
              })()}
            </div>
          }
        />

        {/* PANEL DERECHO — desktop */}
        <aside className="restrictions-panel-compact" style={{ display:'flex', flexDirection:'column', overflow:'hidden' }}>
          <h3 className="king-title">PRESUPUESTO</h3>
          <div style={{ padding: '12px', background: '#0a0f19', borderRadius: '8px', marginBottom: '16px', border: `1px solid ${disponible < 0 ? '#ff4444' : '#333'}` }}>
            <p style={{ color: disponible < 0 ? '#ff4444' : '#22c55e', fontWeight: 'bold', fontSize: '1.1rem', margin: 0, textAlign: 'center' }}>
              ${disponible.toLocaleString()}
            </p>
          </div>

          {/* Tabs restricciones / comodines aplicados */}
          <div style={{ display: 'flex', gap: '4px', marginBottom: '8px', flexWrap: 'wrap' }}>
            {[
              ['restricciones', 'Restricciones', restriccionesActualizadas.filter(r => !r.anulada).length],
              ['comodines', 'Comodines', efectosComodines.length],
            ].map(([key, label, count]) => (
              <button key={key} onClick={() => setPanelTab(key)} style={{
                flex: 1, minWidth: '80px', padding: '5px', background: panelTab === key ? '#00f2ff22' : '#0a0f19',
                border: `1px solid ${panelTab === key ? '#00f2ff' : '#1e293b'}`,
                borderRadius: '6px', cursor: 'pointer',
                color: panelTab === key ? '#00f2ff' : '#64748b',
                fontSize: '0.68rem', fontWeight: 'bold', transition: '0.2s',
                whiteSpace: 'nowrap',
              }}>
                {label} {count > 0 && <span style={{ opacity: 0.7 }}>({count})</span>}
              </button>
            ))}
          </div>

          <div className="restrictions-list-compact" style={{ flex:1, overflowY:'auto', paddingRight:'4px' }}>
            {panelTab === 'restricciones' && (equipoHistorico ? (
              // Mostrar restricciones de la jornada histórica
              (equipoHistorico.restricciones || []).filter(r => !r.anulada).map((res, i) => (
                <div key={i} className={`restriction-item ${res.cumplida ? 'success' : 'failed'}`}>
                  <span className="status-icon">{res.cumplida ? '✓' : '✗'}</span>
                  <span className="restriction-text">{res.texto}</span>
                </div>
              ))
            ) : restriccionesActualizadas.map((res, i) => (
              <div key={i}
                className={`restriction-item ${res.anulada ? 'anulada' : res.cumplida ? 'success' : 'failed'}`}
                onMouseEnter={() => !res.anulada && res.jugadoresRelevantes?.length > 0 && setRestriccionHover(res.jugadoresRelevantes.map(j => j.id))}
                onMouseLeave={() => setRestriccionHover(null)}>
                <span className="status-icon">
                  {res.anulada ? '✕' : res.esExtra ? '' : res.cumplida ? '✓' : '✗'}
                </span>
                <span className="restriction-text">{res.texto}</span>
              </div>
            )))}

            {panelTab === 'comodines' && (
              efectosComodines.length === 0
                ? <p style={{ color: '#334155', fontSize: '0.82rem', textAlign: 'center', margin: '12px 0' }}>Sin efectos aplicados</p>
                : efectosComodines.map((ef, i) => {
                    // Normalizar campos — pueden venir como emoji/texto o tipo/descripcion/monto
                    const esNegativo = (ef.monto || 0) < 0 || ef.tipo === 'trampa_combo' || ef.tipo === 'trampa_retroceso';
                    const color = esNegativo ? '#ff4444' : '#22c55e';
                    const emoji = ef.emoji || (ef.tipo === 'trampa_combo' ? '💸' : ef.tipo === 'trampa_retroceso' ? '' : ef.monto > 0 ? '' : '');
                    const texto = ef.texto || ef.descripcion || (ef.monto ? `$${Math.abs(ef.monto).toLocaleString()} ${ef.monto > 0 ? 'ganados' : 'perdidos'}` : ef.tipo);
                    return (
                      <div key={i} style={{
                        display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px',
                        borderRadius: '4px', border: `1px solid ${color}44`,
                        background: `${color}0a`, fontSize: '0.78rem', color,
                      }}>
                        <span style={{ flexShrink: 0 }}>{emoji}</span>
                        <span>{texto}</span>
                      </div>
                    );
                  })
            )}
          </div>

          {/* BOTÓN CONFIRMAR — solo en jornada activa */}
          <div style={{ marginTop: '12px', flexShrink: 0 }}>
            {equipoHistorico ? (
              <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                <p style={{ color: '#64748b', fontWeight: 'bold', fontSize: '0.85rem', margin: 0 }}>J{jornadaViendoLocal} — Solo lectura</p>
              </div>
            ) : confirmado ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ background: '#22c55e22', border: '1px solid #22c55e44', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                  <p style={{ color: '#22c55e', fontWeight: 'bold', fontSize: '0.85rem', margin: 0 }}>✓ Equipo confirmado</p>
                </div>
                {ventanaAbierta() && (
                  <button onClick={async () => {
                    await supabase.from('drafts').update({ confirmado: false })
                      .eq('user_id', session.user.id).eq('jornada', jornadaActiva);
                    setConfirmado(false);
                    mostrarToast('Podés editar tu equipo hasta el cierre de la ventana', 'ok');
                  }} style={{
                    width: '100%', background: 'transparent', color: '#f59e0b',
                    border: '1px solid #f59e0b55', borderRadius: '8px', padding: '8px',
                    fontWeight: 'bold', fontSize: '0.8rem', cursor: 'pointer',
                  }}>
                    Editar equipo
                  </button>
                )}
              </div>
            ) : !ventanaAbierta() ? (
              <div style={{ background: '#ff444422', border: '1px solid #ff444444', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                <p style={{ color: '#ff4444', fontWeight: 'bold', fontSize: '0.85rem', margin: 0 }}>Ventana cerrada</p>
                <p style={{ color: '#64748b', fontSize: '0.7rem', margin: '4px 0 0' }}>No se permiten cambios</p>
              </div>
            ) : (
              <button onClick={pedirConfirmacion} disabled={confirmando} style={{
                width: '100%', background: '#00f2ff', color: '#000', border: 'none',
                borderRadius: '8px', padding: '10px', fontWeight: 'bold',
                fontSize: '0.85rem', cursor: 'pointer', transition: '0.2s',
              }}>
                {confirmando ? 'Confirmando...' : '✓ Confirmar equipo'}
              </button>
            )}
          </div>
        </aside>
      </div>
    </div>{/* fin tactical-screen-container */}
      {/* ── PANEL MOBILE: tabs debajo de la cancha ── */}
      <div className="tactico-mobile-panel">
        {/* Tabs + presupuesto en la misma fila */}
        <div className="tactico-mobile-tabs">
          {[
            { key: 'suplentes', label: 'Suplentes' },
            { key: 'restricciones', label: `Restricc. (${restriccionesActualizadas.filter(r=>!r.anulada).length})` },
            { key: 'comodines', label: `Comods.${efectosComodines.length > 0 ? ` (${efectosComodines.length})` : ''}` },
          ].map(({ key, label }) => (
            <button key={key} className={`tactico-mobile-tab${mobileTab === key ? ' activo' : ''}`} onClick={() => setMobileTab(key)}>
              {label}
            </button>
          ))}
          {/* Presupuesto inline */}
          <div className="tactico-mobile-presupuesto">
            <span style={{ color: disponible < 0 ? '#ef4444' : '#22c55e', fontWeight: 'bold', fontSize: '0.72rem' }}>
              ${(disponible / 1000000).toFixed(1)}M
            </span>
          </div>
        </div>

        {/* Contenido del tab */}
        <div className="tactico-mobile-content">
          {mobileTab === 'suplentes' && (
            <div className="tactico-mobile-suplentes">
              {CONFIG_SUPLENTES.map(slot => {
                const jug = (equipoHistorico ? equipoHistorico.equipo || {} : equipoActual)[slot.id];
                return (
                  <div key={slot.id} className={`subs-slot-compact${slotSeleccionado === slot.id ? ' slot-selected' : ''}`} onClick={(e) => handleClickSuplente(e, slot)}>
                    <div className="card-cancha-wrap">
                      <CardJugador jugador={jug} posicion={slot.pos} nombre={slot.label} isMini puntos={puntajeVisible[jug?.id] ?? null} />
                      {jug && <span className="card-nombre-ext">{jug.apellido}{jug.nombre ? ` ${jug.nombre.charAt(0)}.` : ''}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {mobileTab === 'restricciones' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {(equipoHistorico ? (equipoHistorico.restricciones || []).filter(r => !r.anulada) : restriccionesActualizadas).map((res, i) => (
                <div key={i}
                  className={`restriction-item ${res.anulada ? 'anulada' : res.cumplida ? 'success' : 'failed'}`}
                  onClick={() => !res.cumplida && !res.anulada && res.jugadoresRelevantes?.length > 0 && setRestriccionSeleccionada(res)}
                  style={{ cursor: !res.cumplida && !res.anulada ? 'pointer' : 'default' }}>
                  <span className="status-icon">{res.anulada ? '✕' : res.esExtra ? '😈' : res.cumplida ? '✓' : '✗'}</span>
                  <span className="restriction-text">{res.texto}</span>
                  {!res.cumplida && !res.anulada && res.jugadoresRelevantes?.length > 0 && (
                    <span style={{ fontSize: '0.6rem', color: '#ef4444', marginLeft: 'auto', flexShrink: 0 }}>ver</span>
                  )}
                </div>
              ))}
              {/* Mini modal restricción seleccionada */}
              {restriccionSeleccionada && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 9999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
                  onClick={() => setRestriccionSeleccionada(null)}>
                  <div style={{ background: '#0f172a', border: '1px solid #ef444466', borderRadius: '14px 14px 0 0', padding: '20px 16px', width: '100%', maxWidth: '480px' }}
                    onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                      <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '0.85rem' }}>✗ {restriccionSeleccionada.texto}</span>
                      <button onClick={() => setRestriccionSeleccionada(null)} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '1.2rem', cursor: 'pointer' }}>×</button>
                    </div>
                    <p style={{ color: '#64748b', fontSize: '0.72rem', margin: '0 0 10px' }}>
                      Jugadores que influyen en esta restricción:
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '200px', overflowY: 'auto' }}>
                      {restriccionSeleccionada.jugadoresRelevantes.map((j, idx) => (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', background: '#1e293b', borderRadius: '8px' }}>
                          <span style={{ background: '#ef444422', border: '1px solid #ef444444', borderRadius: '4px', padding: '1px 6px', fontSize: '0.65rem', color: '#ef4444', fontWeight: 'bold' }}>
                            {j.posicion?.sigla || '??'}
                          </span>
                          <span style={{ color: '#e2e8f0', fontSize: '0.82rem' }}>{j.apellido}{j.nombre ? `, ${j.nombre.split(' ')[0]}` : ''}</span>
                          <span style={{ color: '#475569', fontSize: '0.7rem', marginLeft: 'auto' }}>{j.club?.sigla || j.seleccion || ''}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {restriccionesActualizadas.length === 0 && !equipoHistorico && (
                <p style={{ color: '#334155', fontSize: '0.8rem', textAlign: 'center', margin: '8px 0' }}>Sin restricciones</p>
              )}
            </div>
          )}

          {mobileTab === 'comodines' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {efectosComodines.length === 0
                ? <p style={{ color: '#334155', fontSize: '0.82rem', textAlign: 'center', margin: '8px 0' }}>Sin efectos aplicados</p>
                : efectosComodines.map((ef, i) => {
                    const esNegativo = (ef.monto || 0) < 0 || ef.tipo === 'trampa_combo' || ef.tipo === 'trampa_retroceso';
                    const color = esNegativo ? '#ff4444' : '#22c55e';
                    const emoji = ef.emoji || (ef.tipo === 'trampa_combo' ? '💸' : ef.tipo === 'trampa_retroceso' ? '' : ef.monto > 0 ? '' : '');
                    const texto = ef.texto || ef.descripcion || (ef.monto ? `$${Math.abs(ef.monto).toLocaleString()} ${ef.monto > 0 ? 'ganados' : 'perdidos'}` : ef.tipo);
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', borderRadius: '4px', border: `1px solid ${color}44`, background: `${color}0a`, fontSize: '0.78rem', color }}>
                        <span style={{ flexShrink: 0 }}>{emoji}</span>
                        <span>{texto}</span>
                      </div>
                    );
                  })
              }
            </div>
          )}
        </div>

        {/* Botón confirmar mobile */}
        <div className="tactico-mobile-confirmar">
          {equipoHistorico ? (
            <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
              <p style={{ color: '#64748b', fontWeight: 'bold', fontSize: '0.85rem', margin: 0 }}> J{jornadaViendoLocal} — Solo lectura</p>
            </div>
          ) : confirmado ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div style={{ background: '#22c55e22', border: '1px solid #22c55e44', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                <p style={{ color: '#22c55e', fontWeight: 'bold', fontSize: '0.9rem', margin: 0 }}>✓ Equipo confirmado</p>
              </div>
              {ventanaAbierta() && (
                <button onClick={async () => {
                  await supabase.from('drafts').update({ confirmado: false })
                    .eq('user_id', session.user.id).eq('jornada', jornadaActiva);
                  setConfirmado(false);
                  mostrarToast('Podés editar tu equipo hasta el cierre de la ventana', 'ok');
                }} style={{
                  width: '100%', background: 'transparent', color: '#f59e0b',
                  border: '1px solid #f59e0b55', borderRadius: '8px', padding: '10px',
                  fontWeight: 'bold', fontSize: '0.9rem', cursor: 'pointer',
                }}>
                  Editar equipo
                </button>
              )}
            </div>
          ) : !ventanaAbierta() ? (
            <div style={{ background: '#ff444422', border: '1px solid #ff444444', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
              <p style={{ color: '#ff4444', fontWeight: 'bold', fontSize: '0.9rem', margin: 0 }}>Ventana cerrada</p>
            </div>
          ) : (
            <button onClick={pedirConfirmacion} disabled={confirmando} style={{ width: '100%', background: '#00f2ff', color: '#000', border: 'none', borderRadius: '8px', padding: '12px', fontWeight: 'bold', fontSize: '0.95rem', cursor: 'pointer' }}>
              {confirmando ? 'Confirmando...' : '✓ Confirmar equipo'}
            </button>
          )}
        </div>
      </div>

      <MenuContextual
        menuContextual={menuContextual}
        equipo={equipoActual}
        posActual={posActual}
        configSuplentes={CONFIG_SUPLENTES}
        onTransferir={() => {
          setPosicionSeleccionada(menuContextual.pos);
          setIndexAEditar(menuContextual.index);
          setMenuContextual(null);
          setMercadoAbierto(true);
        }}
        onIntercambiar={handleIntercambiar}
        onQuitar={handleQuitar}
        onCerrar={cerrarTodo}
        capitanIndex={capitanIndex}
        onCapitan={handleCapitan}
      />

      {/* ⚠️ NO BORRAR: Toast de notificaciones */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: '28px', left: '50%', transform: 'translateX(-50%)',
          background: toast.tipo === 'error' ? '#1a0808' : '#081a08',
          border: `1px solid ${toast.tipo === 'error' ? '#ef444466' : '#22c55e66'}`,
          color: toast.tipo === 'error' ? '#ef4444' : '#22c55e',
          padding: '12px 24px', borderRadius: '10px', fontSize: '0.9rem', fontWeight: 'bold',
          zIndex: 99999, boxShadow: '0 4px 24px rgba(0,0,0,0.6)',
          whiteSpace: 'pre-wrap', maxWidth: '500px', textAlign: 'center',
        }}>
          {toast.tipo === 'error' ? '⚠️ ' : '✓ '}{toast.msg}
        </div>
      )}
      <Tutorial tutorialId="equipo_tactico" userId={session?.user?.id} pasos={TUTORIALES.equipo_tactico} botonVerDeNuevo={true}/>
      {/* Modal confirmación */}
      {mostrarConfirmar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#0f172a', border: '1px solid #00f2ff44', borderRadius: '14px', padding: '28px 32px', maxWidth: '380px', width: '90%', textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '10px' }}></div>
            <h3 style={{ color: '#fff', margin: '0 0 8px', fontSize: '1.1rem' }}>¿Confirmar equipo?</h3>
            <p style={{ color: '#94a3b8', fontSize: '0.88rem', margin: '0 0 20px', lineHeight: 1.5 }}>
              <strong style={{ color: '#fff' }}>Recorda que cuando falten 30 minutos para el inicio de la fecha no podras editar el equipo.</strong>
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={() => setMostrarConfirmar(false)}
                style={{ padding: '10px 24px', background: 'transparent', border: '1px solid #334155', borderRadius: '8px', color: '#94a3b8', cursor: 'pointer', fontSize: '0.9rem' }}>
                Cancelar
              </button>
              <button onClick={() => { setMostrarConfirmar(false); confirmarEquipo(); }}
                style={{ padding: '10px 24px', background: '#00f2ff', border: 'none', borderRadius: '8px', color: '#000', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem' }}>
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
      {fixtureWidget}
    </>
  );
};

export default EquipoTactico;